module.exports = __webpack_public_path__ + "img/0e38f2b79721376761c344495ec33a62.png";